export default {
  // Validaciones de formulario de usuario
  user_name_error: 'Debe ingresar al menos un nombre',
  last_name_error: 'Debe Ingresar un apellido o inicial',
  email_error: 'Debe ingresar un correo válido',
  password_error: 'Debe proporcionar una contraseña',
  password_format_error: 'La contraseña debe tener al menos 8 caracteres con números y letras',
  password_confirmation_error: 'Las contraseñas deben coincidir',
  external_id_error: 'El ID externo no debe exceder 100 caracteres',

  // Validaciones de selectores compartidos (roles, franquicias)
  role_error: 'Seleccione un Rol',
  roles_error: 'Seleccione roles',
  select_franchise_error: 'Debe seleccionar una unidad de negocio',

  // Otras validaciones
  logo_process_error: 'No se pudo procesar la imagen del logo',
  organization_save_error: 'No se pudo guardar la organización',
  organization_delete_error: 'No se pudo eliminar la organización',
  sort_type_error: 'No se pudo actualizar el tipo de orden del nivel',
  same_role: 'Los roles no pueden ser iguales',
  code_not_found: 'Código no encontrado: {code}',
  scan_area: 'Coloque un código dentro del área de escaneo',
  scan_error: 'Error al iniciar el scanner',
  scan_permission_denied: 'Se necesita permiso de cámara para escanear códigos. Revise los permisos de la app.',
  scan_module_installing: 'Preparando el escáner por primera vez, intente de nuevo en unos segundos.',

  // Formularios: campos obligatorios y validaciones de formularios/pruebas
  occurrence_open_forbidden: 'No tienes este rol asignado en esta ubicación.',
  occurrence_open_failed: 'No se pudo abrir el formulario. Verifica tu conexión.',
  video_invalid: 'Formato de video no soportado.',
  photo_limit_reached: 'Ya alcanzaste el límite de {limit} fotos para esta pregunta.',
  photo_limit_truncated: 'Solo se agregaron {added} de {selected} fotos seleccionadas (límite de {limit}).',
  addon_sync_failed: 'No se pudo sincronizar esta pregunta con el servidor. Revisa tu conexión.',
  notify_comment_required: 'Debe proporcionar un comentario',
  validation_name_required: 'Debes escribir un nombre',
  validation_role_required: 'Debes elegir algún rol',
  validation_audited_required: 'Selecciona al auditado',
  validation_supervisor_required: 'Selecciona al supervisor',
  validation_franchise_required: 'Selecciona una unidad de negocio',
  signature_required_label: 'Firma principal obligatoria',
  signature_secondary_required_label: 'Firma secundaria obligatoria',
  signature_additional_required_label: 'Firmas adicionales obligatorias',
  validation_days_positive: 'Debe ser mayor a 0',

  // Carga de imágenes y ubicaciones (encuestas, formularios asignados)
  image_upload_error: 'Error al subir la imagen',
  image_file_invalid: 'El archivo debe ser una imagen',
  locations_load_error: 'No se pudieron cargar las ubicaciones. Verifica tu conexión.',

  // Licencias: razón de suspensión/reactivación
  reason_required: 'Elige una razón',
  reason_detail_required: 'Describe la razón',
  reason_detail_max: 'Máximo 2000 caracteres',

  // Ocurrencia: errores al finalizar, sincronizar y autorizar
  occurrence_tasks_save_error: 'Error al guardar las tareas',
  occurrence_deadline_expired: 'El tiempo límite para enviar este formulario ha expirado',
  occurrence_not_saved: 'La información no fue guardada.',
  occurrence_sync_check_title: 'Error de validación',
  occurrence_sync_check_error: 'Ocurrió un error al validar la sincronización. Intenta nuevamente.',
  occurrence_load_sync_error: 'Error al cargar o sincronizar la auditoría',
  occurrence_authorize_error: 'Error al autorizar el formulario',
  occurrence_signature_not_saved: 'No se pudo guardar la firma. Se volverá a enviar en el siguiente guardado con conexión.',
  occurrence_signature_syncing: 'La firma todavía se está sincronizando. Intenta borrarla en unos segundos.',
  occurrence_signature_delete_error: 'No se pudo borrar la firma. Intenta nuevamente.',
  occurrence_document_not_saved: 'No se pudo guardar el documento. Vuelve a adjuntarlo.',
  occurrence_comment_not_saved: 'No se pudo guardar el comentario. Vuelve a escribirlo.',
  occurrence_not_found_for_date: 'No existe el formulario en la fecha seleccionada',
  occurrence_answers_send_error: 'No pudieron ser enviadas las respuestas',
  occurrence_task_user_invalid: 'No se pudo validar el usuario asignado',
  occurrence_changes_save_error: 'Error al guardar los cambios',
  occurrence_task_duplicate: 'Esta tarea ya existe en la auditoría',
  occurrence_only_documents_allowed: 'Solo puedes subir documentos',
  occurrence_document_show_error: 'Error al mostrar el documento, por favor intenta recargando la página.',
  occurrence_invalid_time: 'Hora no válida',
  // Prueba de formulario (FormTest*)
  form_test_add_comment_no_occurrence: 'Error: No se puede agregar comentario sin test occurrence',
  form_test_add_comment_error: 'Error al agregar comentario de prueba',
  form_test_add_picture_no_occurrence: 'Error: No se puede agregar imagen sin test occurrence',
  form_test_add_picture_error: 'Error al agregar imagen de prueba',
  form_test_save_comment_error: 'Error al guardar comentario de prueba',
  form_test_save_picture_error: 'Error al guardar imagen de prueba'
}
